import { Component, OnInit } from '@angular/core';
import { SidebarComponent } from "../sidebar/sidebar.component";
import { HeaderComponent } from "../header/header.component";
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbComponent } from "../../../shared/components/breadcrumb/breadcrumb.component";

@Component({
  selector: 'app-admin-layout',
  imports: [RouterOutlet, TranslateModule, SidebarComponent, HeaderComponent, BreadcrumbComponent],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.css'
})
export class AdminLayoutComponent implements OnInit {
  // This method is used to initialize the class instance
  constructor() {
  }
  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
  }

  sidebarOpen = false;
  // This method is used to handle header menu click event
  onHeaderMenuClick() {
    this.sidebarOpen = !this.sidebarOpen;
  }

  // This method is used to handle sidebar close event
  onSidebarClose() {
    this.sidebarOpen = false;
  }
}
